import { render, staticRenderFns } from "./SfCategoryMenuCard.vue?vue&type=template&id=5bf8f010"
import script from "./SfCategoryMenuCard.vue?vue&type=script&lang=js"
export * from "./SfCategoryMenuCard.vue?vue&type=script&lang=js"
import style0 from "./SfCategoryMenuCard.vue?vue&type=style&index=0&id=5bf8f010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports